<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_5443_5390)">
      <path d="M9.4397 0.0515218C14.9351 -0.256393 19.6386 3.95139 19.9419 9.44707C20.2453 14.9427 16.0336 19.6426 10.5377 19.9414C5.04817 20.24 0.35493 16.0343 0.0519119 10.5451C-0.251119 5.05578 3.95069 0.359074 9.4397 0.0515218Z" 
      fill="url(#paint0_linear_5443_5390)"/>
      <path d="M8.77789 9.44857C8.81816 9.44645 8.85846 9.44501 8.89878 9.44427C9.75581 9.42899 10.7129 9.41967 11.5672 9.47634C12.2111 9.51907 12.9975 9.96158 13.4565 10.4086C14.0848 11.0218 14.4418 11.8608 14.4479 12.7388C14.4515 13.0127 14.4179 13.9741 14.3469 14.2047C14.2976 14.3655 14.2103 14.512 14.0923 14.6317C13.9498 14.776 13.7703 14.878 13.5734 14.9265C13.3515 14.9813 12.8658 14.9649 12.6134 14.9652L11.25 14.9664L8.03332 14.9671H7.1386C6.68657 14.9665 6.31711 15.0111 5.95512 14.691C5.73384 14.4949 5.60166 14.2174 5.58884 13.9219C5.57673 13.6837 5.60945 13.3726 5.61877 13.1271C5.6379 12.8262 5.62823 12.5135 5.67684 12.2155C5.93096 10.6576 7.2221 9.53394 8.77789 9.44857Z" 
      fill="#FEFEFE" />
      <path d="M9.80173 3.37275C10.2857 3.29767 10.8853 3.51713 11.2614 3.81446C12.3679 4.68908 12.5047 6.4294 11.6324 7.51479C11.2761 7.95814 10.7888 8.25001 10.2216 8.31487C10.2125 8.31634 10.2033 8.31764 10.1941 8.3188C9.68098 8.38337 9.16702 8.22101 8.75964 7.90941C7.12268 6.65729 7.62023 3.64825 9.80173 3.37275Z" 
      fill="#FEFEFE" />
      <path d="M14.5355 5.58692C15.339 5.48504 15.9154 6.15767 16.0433 6.89972C16.1821 7.70512 15.7623 8.73096 14.8736 8.87008C14.5417 8.91626 14.2762 8.85291 14.0001 8.66427C12.9216 7.9271 13.1424 5.79794 14.5355 5.58692Z" 
      fill="#FEFEFE" />
      <path d="M5.12481 5.58625C5.31297 5.5727 5.48343 5.57086 5.66386 5.63513C7.07187 6.13666 6.9924 8.53157 5.50184 8.86696C5.19245 8.92117 4.87415 8.85147 4.61573 8.67293C3.52871 7.9359 3.73536 5.83121 5.12481 5.58625Z" 
      fill="#FEFEFE" />
      <path d="M4.67292 10.0054C4.75591 9.9917 5.00887 9.99701 5.10085 9.99753C4.38695 10.8088 4.06144 11.9617 4.10493 13.0249C4.1174 13.3302 4.09288 13.551 4.16626 13.8601C3.86179 13.8598 3.03313 13.8922 2.78852 13.8006C2.47789 13.6491 2.29387 13.4075 2.2631 13.0552C2.1267 11.4929 3.04327 10.1653 4.67292 10.0054Z" 
      fill="#FEFEFE" />
      <path d="M14.8959 9.99907C15.8876 9.93573 16.8056 10.3838 17.3349 11.2322C17.6615 11.7559 17.7394 12.2637 17.7267 12.8698C17.7194 13.2175 17.6951 13.3863 17.4393 13.6417C17.1249 13.8999 16.8382 13.8614 16.4544 13.8598L15.8122 13.8568C15.842 13.7499 15.8625 13.6405 15.8731 13.5299C15.8908 13.3413 15.879 13.1588 15.8846 12.9725C15.917 11.9045 15.5885 10.8324 14.8959 9.99907Z" 
      fill="#FEFEFE" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_5443_5390" x1="9.99692" y1="0.0356445" x2="9.99692" y2="19.9564" gradientUnits="userSpaceOnUse">
        <stop stop-color="#59B3F9" />
        <stop offset="1" stop-color="#2A63D9" />
      </linearGradient>
      <clipPath id="clip0_5443_5390">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'FBGroupsPlatformIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>